// extracted by css-extract-rspack-plugin
export default {"Link":"TransferredEvent-module__Link__ElTLuzS"};